<template>
  <div>
    <basic-container>
      <div class="title-warp">
        <h3 class="title">印章列表</h3>
        <el-button size="small" type="primary" style="margin-left: 30px" @click="handleOpenCreateSignatureDialog">+新建签章</el-button>
      </div>
      <el-table :data="tableData" height="600" border>
        <el-table-column label="印章类型" align="center">
          <template slot-scope="scope">
            {{scope.row.signatureImgType | signatureImgType}}
          </template>
        </el-table-column>
        <el-table-column label="主体" prop="companyName" align="center" />
        <el-table-column label="印章样式" prop="endTime" align="center">
          <template slot-scope="scope">
            <img class="signature-img" :src="scope.row.image" alt="">
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDelSignature(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </basic-container>
    <auth-dialog ref="authDialog" @success="handleAuthSuccess"></auth-dialog>
    <el-dialog title="创建签章" :visible.sync="dialogSignature" :show-close="false" width="400px" class="auth-dialog">
      <el-form ref="authForm" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="印章类型" prop="signatureImgType">
          <el-select v-model="form.signatureImgType" style="width: 95%" placeholder="请选择印章类型" @change="handleChangeSignature">
            <el-option label="公章" :value="1"></el-option>
            <el-option label="合同专用章" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="signature-img-wrap" :class="{disabled: !disabled}" @click="handleCreateSignature">
            <img v-if="signatureImg" :src="signatureImg" alt="">
            <span v-else>生成电子签章</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :disabled="!signatureImg" type="primary" @click="saveSignatureImg">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AuthDialog from '../components/AuthDialog.vue'
export default {
  components: { AuthDialog },
  data() {
    return {
      tableData: [],
      dialogSignature: false,
      signatureImg: '',
      licenseName: '',
      regCode: '',
      form: {
        signatureImgType: ''
      },
      rules: {
        signatureImgType: [
          { required: true, message: '请选择印章类型', trigger: 'change'}
        ]
      }
    }
  },
  computed: {
    disabled () {
      return this.form.signatureImgType
    }
  },
  activated() {
    this.getSignatureImgListByGroupId()
  },
  methods: {
    handleChangeSignature () {
      this.signatureImg = ''
      this.licenseName = ''
    },
    async handleOpenCreateSignatureDialog() {
      try {
        let result = await this.judgeCompanyRegistered()
        if (result) {
          this.dialogSignature = true
          this.signatureImg = ''
          this.licenseName = ''
          return
        }
        this.$refs.authDialog.show()
      } catch (error) {
      }
    },
    handleAuthSuccess () {
      this.dialogSignature = true
      this.signatureImg = ''
      this.licenseName = ''
    },
    async handleCreateSignature() {
      const res = await _api.contract.generateSignatureImg(this.form)
      if (!res || !res.ret || !res.data) {
        return
      }
      this.signatureImg = res.data.image
      this.regCode = res.data.regCode
      this.licenseName = res.data.licenseName
    },
    async saveSignatureImg() {
      const res = await _api.contract.saveSignatureImg({
        image: this.signatureImg, 
        regCode: this.regCode, 
        licenseName: this.licenseName,
        ...this.form
      })
      if (!res.ret || !res.data.success) {
        return
      }
      this.$message({
        message: '签章保存成功',
        type: 'success'
      });
      this.dialogSignature = false
      this.getSignatureImgListByGroupId()
    },
    async handleDelSignature (data) {
      const res = await _api.contract.deleteSignatureImg({signatureImgId: data.signatureImgId})
      if (!res || !res.ret || !res.data) {
        return
      }
      this.getSignatureImgListByGroupId()
    },
    async getSignatureImgListByGroupId() {
      const res = await _api.contract.getSignatureImgListByGroupId()
      if (!res || !res.ret || !res.data) {
        this.tableData = []
        this.isLoaded = true
        return
      }
      this.tableData = res.data ||  []
    },
    async judgeCompanyRegistered() {
      const res = await _api.contract.judgeCompanyRegistered()
      if (!res || !res.ret || !res.data) {
        if (res.error.code === 4003) {
          return false
        }
        return Promise.reject()
      }
      return res.data.success
    }
  },
  filters: {
    signatureImgType (value) {
      switch (value) {
        case 1:
          return '公章'
        case 2:
          return '合同专用章'
        default:
          return ''
      }
    }
  }
}
</script>
<style scoped>
.title-warp {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.title {
  font-size: 16px;
  color: #409eff;
}
.auth-dialog >>> .el-dialog__body {
  padding: 0 20px;
}
.auth-dialog>>> .el-input {
  width: 100%;
}
.no-appoint {
  color: #FF4500;
  text-align: center;
  height: 500px;
  margin-top: 60px;
}
.signature-img {
  width: 100px;
  height: 100px;
}
.signature-img-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  background-color: rgb(239,239,239);
  font-size: 16px;
  color: #409eff;
}
.signature-img-wrap.disabled {
  color: rgb(200,200,200)
}
.signature-img-wrap img {
  width: 150px;
  height: 150px;
}
</style>
